<template>
  <div class="forma-erp kasa-izbornik">

    <div class="traka-ekrana mb-3">
      <div class="naslov">Kasa</div>
      <div class="brojka">
        <span>Firma</span>
        <b>{{ nazivFirme }}</b>
      </div>
      <div class="brojka" v-if="skladiste">
        <span>Skladište</span>
        <b>{{ skladiste }}</b>
      </div>
      <v-spacer></v-spacer>
      <v-progress-circular v-if="ucitavam" indeterminate color="primary" size="20"></v-progress-circular>
    </div>

    <!-- Racun bez JIR-a se ne smije izgubiti iz vida, pa stoji odmah na ulazu
         u kasu, a ne tek na popisu. -->
    <div class="upozorenje mb-3" v-if="cekaju > 0" @click="idi('/crm/kasa/racuni')">
      <v-icon color="orange darken-3">mdi-clock-alert-outline</v-icon>
      <div>
        <b>{{ cekaju }} {{ cekaju === 1 ? 'račun čeka' : 'računa čeka' }} fiskalizaciju.</b>
        <span class="uz">Klik otvara popis.</span>
      </div>
    </div>

    <div class="plocice">
      <div
        v-for="p in plocice"
        :key="p.put"
        class="plocica"
        :class="{probna: p.probna}"
        tabindex="0"
        @click="idi(p.put)"
        @keydown.enter.prevent="idi(p.put)"
      >
        <v-icon :color="p.probna ? 'grey darken-1' : 'primary'" size="34">{{ p.ikona }}</v-icon>
        <div class="tekst">
          <div class="ime">
            {{ p.naziv }}
            <span class="znak" v-if="p.probna">stara</span>
            <span class="znak cekaju" v-if="p.znak">{{ p.znak }}</span>
          </div>
          <div class="opis">{{ p.opis }}</div>
        </div>
        <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
      </div>
    </div>

  </div>
</template>

<script>
import KasaService from '@/services/KasaService'

export default {
  name: 'kasaizbornik',

  data () {
    return {
      cekaju: 0,
      ucitavam: false
    }
  },

  computed: {
    nazivFirme () {
      return this.$store.state.companyName || ''
    },
    skladiste () {
      return this.$store.state.warehousemarkid || ''
    },
    plocice () {
      return [
        {
          naziv: 'Kasa',
          opis: 'Izdavanje računa — skener i tipkovnica',
          ikona: 'mdi-cash-register',
          put: '/crm/kasa'
        },
        {
          naziv: 'Računi',
          opis: 'Pregled izdanih i slanje onih bez JIR-a',
          ikona: 'mdi-receipt-text-outline',
          put: '/crm/kasa/racuni',
          znak: this.cekaju > 0 ? this.cekaju + ' čeka JIR' : ''
        },
        {
          naziv: 'Obračun',
          opis: 'Zbroj po stopama PDV-a i načinima plaćanja',
          ikona: 'mdi-calculator-variant-outline',
          put: '/crm/kasa/obracun'
        },
        {
          // Stara kasa ostaje dostupna dok se nova ne provjeri u radu.
          naziv: 'Kasa test',
          opis: 'Stara kasa (Fiskalizacija 1.0)',
          ikona: 'mdi-flask-outline',
          put: '/crm/document/pos',
          probna: true
        }
      ]
    }
  },

  mounted () {
    this.ucitaj()
  },

  methods: {
    // Koliko racuna ceka JIR broji posluzitelj - kasa se zna otvoriti i na
    // drugom racunalu, pa se broj ne smije racunati iz ovog ekrana.
    async ucitaj () {
      this.ucitavam = true
      try {
        const {data} = await KasaService.pocetak({
          CompanyId: this.$store.state.companyid,
          BusinessYear: this.$store.state.businessYear,
          SKLADID: this.$store.state.warehousemarkid || 1
        })
        this.cekaju = data.cekaju || 0
      } catch (err) {
        // Izbornik mora raditi i kad posluzitelj ne odgovori - odavde se ide
        // dalje, a svaki ekran sam javi svoj problem.
        this.cekaju = 0
      } finally {
        this.ucitavam = false
      }
    },

    idi (put) {
      this.$router.push(put).catch(() => {})
    }
  }
}
</script>

<style scoped>
.kasa-izbornik .upozorenje {
  background: #fff8e1;
  border-left: 4px solid #f9a825;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  border-radius: 4px;
}
.kasa-izbornik .upozorenje b { color: #8d6e00; }
.kasa-izbornik .upozorenje .uz { color: #8d6e00; margin-left: 6px; font-weight: 400; font-size: 13px; }

/* Jedna plocica po retku. Prije ih je "auto-fit" slagao u onoliko stupaca
   koliko stane, pa su na sirokom ekranu stajale sve cetiri jedna uz drugu -
   popis od cetiri izbora citljiviji je odozgo prema dolje nego slijeva
   nadesno. */
.kasa-izbornik .plocice {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  /* Stupac je uzi od ekrana i sredisnji: cetiri izbora razvucena preko cijele
     sirine monitora tjeraju oko s lijevog ruba na desni za svaki redak. */
  max-width: 560px;
  margin: 0 auto;
}
/* Upozorenje o nefiskaliziranim racunima stoji iznad plocica i dio je istog
   stupca, pa prati njihovu sirinu - inace visi preko cijele sirine. */
.kasa-izbornik .upozorenje {
  max-width: 560px;
  margin-left: auto;
  margin-right: auto;
}
.kasa-izbornik .plocica {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 18px;
  background: #fff;
  border: 1px solid #dbe2e8;
  border-radius: 6px;
  cursor: pointer;
}
.kasa-izbornik .plocica:hover,
.kasa-izbornik .plocica:focus {
  border-color: #1976d2;
  box-shadow: 0 2px 10px rgba(25, 118, 210, 0.14);
  outline: none;
}
/* Stara kasa je blijeda: tu se ide samo dok nova ne prode provjeru. */
.kasa-izbornik .plocica.probna { background: #fafbfc; }
.kasa-izbornik .plocica .tekst { flex: 1 1 auto; min-width: 0; }
.kasa-izbornik .plocica .ime {
  font-size: 17px;
  font-weight: 700;
  color: #1565c0;
}
.kasa-izbornik .plocica.probna .ime { color: #546e7a; }
.kasa-izbornik .plocica .opis { font-size: 13px; color: #78909c; margin-top: 2px; }
.kasa-izbornik .plocica .znak {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  padding: 1px 6px;
  border-radius: 3px;
  margin-left: 8px;
  background: #eceff1;
  color: #607d8b;
  vertical-align: middle;
}
.kasa-izbornik .plocica .znak.cekaju { background: #fff3e0; color: #e65100; }
</style>
